import { render, staticRenderFns } from "./studentDialog.vue?vue&type=template&id=c57359dc&scoped=true&"
import script from "./studentDialog.vue?vue&type=script&lang=js&"
export * from "./studentDialog.vue?vue&type=script&lang=js&"
import style0 from "./studentDialog.vue?vue&type=style&index=0&id=c57359dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57359dc",
  null
  
)

export default component.exports